import Vue from "vue";
import LiveSelect from "./LiveSelect.vue";
var LiveSelectConstructor = Vue.extend(LiveSelect);

function openLiveSelect(_ref) {
  var webHandler = _ref.webHandler,
      clientHandler = _ref.clientHandler;
  var instance = new LiveSelectConstructor();

  instance.openByWeb = function () {
    webHandler && webHandler();
    instance.$destroy();
    document.body.removeChild(instance.$el);
  };

  instance.openByClient = function () {
    clientHandler && clientHandler();
    instance.$destroy();
    document.body.removeChild(instance.$el);
  };

  instance.$mount();
  document.body.appendChild(instance.$el);
}

Vue.prototype.$courseExtension = {
  openLiveSelect: openLiveSelect
};